module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14LIE8c/media/FC-9781647508234.jpg?1684514917788",
      "alt": "This image is the cover for the book Bloodlines – Harsh Fate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bloodlines – Harsh Fate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "#00000A"
    }
  }, [_vm._v("Bloodlines – Harsh Fate")])]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "#00000A"
    }
  }, [_vm._v(" is a fantasy, set on the continent of Mataan, a land originally inhabited by humans, elves and dwarves, for the most part. A many-decade long war, with a race of people known as Krakons, from across the ocean, has defeated the original races and taken over the lands of Mataan. ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("The human race has been assimilated into Krakon society as a slave class, a few scattered to wild lands in the northwest, now called the Outlaw Kingdom. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "#00000A"
    }
  }, [_vm._v("But there has been a foretelling of a Ravenlock, the old rulers of the dark Wars era, that would rise up once more, unite the races, and renew the war with the Krakons. A Renewing of the first formal Joining, the true sign of this prophecy.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "#00000A"
    }
  }, [_vm._v("This is the story of one of Raklor Ravenlock’s scion, hundreds of years after the Dark Wars, found deep in the mountains of the Outlaw Kingdom – a short and somewhat concise telling of the events, occurrences, and happenings of his formative years. His journey to this fabled renewing.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  })]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W.L. Burke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("W.L. Burke was born, raised and resides in the rocky mountains. He has been living there for the last 30 years, on a small ranch, raising children, horses, dogs, and various sundry types of animals. Some of those were sold, some were raced, some were rescued, and some are kept around as family.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("One of five children, the author quit school at 15 and went to work full time, but recommends this option to no one. A life-long love of reading overcame this shortfall, gaining a diploma and taking some college courses, which, prompted some writing attempts.")])]), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('br')])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0